export default [
    {
        path: `/payments/reports`,
        component: () => import('@/pages/payments/index.vue')
    },
    {
        path: `/payments/reports/list_people`,
        component: () => import('@/pages/payments/index.vue')
    },
    {
        path: `/payments/pledges/fundraiser/:fundraiserId`,
        component: () => import('@/pages/payments/index.vue')
    },
    {
        path: `/payments/reports/graph`,
        component: () => import('@/pages/payments/index.vue')
    }
]
